
import AssetsInfo from '@/components/assets-info/assets-info.vue';
import { mapGetters } from 'vuex';
import Service from '../service.js';
import Service1 from '@/service/index.js';
export default {
  components: {
    AssetsInfo
  },
  data() {
    return {
      massifTypeArr: [],
      projectTypeArr: [],
      Assetslist: [],
      detail: {},
      assetsInfo: [],
      projectInfo: null,
      subTypeObj: {},
      TypeObj: {},
      plotType: '',
      allinfo: {},
      numtype: '',
      assetsLargeTypearr2: [],
      assetsLargeTypearr3: [],
      assetsStatusArr: [
        {code: 0, value: '可用'},
        {code: 1, value: '审核中'},
        {code: 2, value: '交易中'},
        {code: 3, value: '已流转'},
        {code: 4, value: '已到期'}
      ] // 资产状态
    };
  },

  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created () {
    this.query = this.$route.query;
    this.getDetail();
    // this.getType();
    Service1.getSelectList('ASSETS_LARGE_TYPE').then(({ code, data }) => {
      if (code === '0') {
        this.assetsLargeTypearr = data;
        this.assetsLargeTypearr2 = data;
        this.assetsLargeTypearr3 = data;
        this.assetsLargeTypearr.map(res => {
          res.list.map(item => {
            this.TypeObj[`${res.code}-${item.code}`] = item.value;
            this.numtype = this.TypeObj[this.detail.assetsLargeType + '-' + this.detail.projectType];
            item.list.map(subItem => {
              this.subTypeObj[`${res.code}-${item.code}-${subItem.code}`] = subItem.value;
            });
          });
        });
      }
    });
  },
  methods: {
    getType() {
      Service.getDictionaryByCode(this.detail.assetsLargeType, this.detail.projectType).then(res => {
        this.massifTypeArr = res.data;
      });
    },
    getDetail(){
      Service.getSecondListInfo(this.query.id).then(res => {
        if (res && res.code === '0') {
          this.detail = res.data;
          this.getType();
          this.assetsInfo = JSON.parse(res.data.assetsInfo).massifs;
          this.allinfo = JSON.parse(res.data.assetsInfo).massifsInfo;
          this.plotType = JSON.parse(res.data.assetsInfo).massifsInfo.plotType;
        } else {
          errorMessage(res && res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });

    },
    previousStep () {
      this.$router.back();
    }
  }
};
